// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBa-zzH47GJFH8ABJ9bZdgvPSlk0PL_rAw",
  authDomain: "mcnally-ae848.firebaseapp.com",
  databaseURL: "https://mcnally-ae848-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "mcnally-ae848",
  storageBucket: "mcnally-ae848.firebasestorage.app",
  messagingSenderId: "47699518795",
  appId: "1:47699518795:web:af9c40741c3bde3c3774ce",
  measurementId: "G-5ZQJTTX436"
};

export default firebaseConfig;